{
  "customFonts": [
    {
      "family": "Fairplex Medium",
      "variants": [
        { "weight": 500, "style": "normal", "src": "/fonts/custom/Fairplex-Medium.otf" }
      ],
      "fallback": "serif"
    },
    { 
      "family": "RocoOne",
      "variants": [
        { "weight": 400, "style": "normal", "src": "/fonts/custom/RocaOne.ttf" }
      ],
      "fallback": "sans-serif"
    },
    { 
      "family": "Moderat Medium",
      "variants": [
        { "weight": 500, "style": "normal", "src": "/fonts/custom/moderat-Medium.ttf" }
      ],
      "fallback": "serif"
    }
  ]
}
